import { formattedPriceStringFromPence } from '@daymade/common-lib/formatting';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import styles from './OrderSummaryCosts.module.css';

const OrderSummaryCosts = observer(() => {
  const { orderCost, discountBannerText, discountThisWeekText } =
    useEnterStore();

  const isDiscounted = orderCost.price !== orderCost.cost;
  return (
    <div className={styles.container}>
      {discountBannerText && (
        <div className={styles.discountBannerWrapper}>
          <span className={styles.discountBanner + ' aboutUsTypographyCaption'}>
            {discountBannerText}
          </span>
        </div>
      )}
      <dl className={styles.mainSummary}>
        <dt>Weekly Subscription</dt>
        <dd>{formattedPriceStringFromPence(orderCost.price)} / week</dd>
        {isDiscounted && (
          <dt>
            This week
            <br />
            {discountThisWeekText && (
              <span
                className={
                  styles.discountThisWeek + ' aboutUsTypographyCaption'
                }
              >
                {discountThisWeekText}
              </span>
            )}
          </dt>
        )}
        {isDiscounted && (
          <dd>
            <span className={styles.fullPrice}>
              {formattedPriceStringFromPence(orderCost.price)}
            </span>{' '}
            <span className={styles.currentPrice}>
              {formattedPriceStringFromPence(orderCost.cost)}
            </span>
          </dd>
        )}
      </dl>
    </div>
  );
});

export default OrderSummaryCosts;
